import React from "react";
import {
  Grid,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  alpha,
} from "@mui/material";
import { motion } from "framer-motion";
import { VideoPlayer } from "./HelpDialogItems";

const FunctionsSwitcherGrid = ({ functions }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!functions || functions.length === 0) {
    return <Typography>No functions available</Typography>;
  }

  return (
    <Grid container spacing={6}>
      {functions.map((func, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Box
            component={motion.div}
            whileHover={{ y: -4 }}
            transition={{ duration: 0.2 }}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              borderRadius: "12px",
              overflow: "hidden",
              backgroundColor: theme.palette.background.paper,
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              transition: "all 0.2s ease",
              "&:hover": {
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
              },
            }}
          >
            {/* Title and Description Section */}
            <Box
              sx={{
                p: 5,
                pb: 4,
              }}
            >
              <Typography
                variant="h6"
                fontWeight={600}
                gutterBottom
                color="text.primary"
              >
                {func.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: "1.05rem",
                  mb: 2,
                }}
              >
                {func.subtitle || func.description}
              </Typography>
            </Box>

            {/* Video Section */}
            <Box
              sx={{
                width: "100%",
                mt: "auto",

                overflow: "hidden",
              }}
            >
              <VideoPlayer
                key={func.videoUrl}
                videoUrl={func.videoUrl}
                poster={func.poster}
                autoPlay={false}
                gridDisplay={true}
              />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default FunctionsSwitcherGrid;
